export const mappingResellerForLabraUI = {
  ISV: 'isvName',
  'Authorization name': 'authorizationName',
  Product: 'productName',
  'End date': 'endDate',
  Status: 'status',
  '': 'actions',
}

export const customCloudSelectorOptions = [
  { name: 'AWS', disabled: false },
  { name: 'GCP', disabled: true },
  { name: 'AZURE', disabled: true },
]
